import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { AxiosRequestConfig } from "axios";
import type {UserType} from "@/types/UserType";
import posthog from '@/posthog';
@Module
export default class UserPublicModule extends VuexModule {
    errors = {};
    user = {} as UserType;

    /**
     * Get public user object
     * @returns User
     */
    get publicUser(): UserType {
        return this.user;
    }

    @Action
    async [Actions.GET_PUBLIC_USER](id: number) {
        try {
         
            const response: any = await ApiService.get('/public/profile/'+id['id']);
           this.context.commit(Mutations.SET_PUBLIC_USER, response.data.data);

              posthog.capture('viewed_public_profile', {
                user_id: id,
                name: response.data.data.name,
                nickname: response.data.data.nick,
                patent: response.data.data.user_patent?.name,
                score: response.data.data.score,
                machines_completed: response.data.data.machines_completed,
                challenges_completed: response.data.data.challenges_completed,
                courses_completed: response.data.data.courses_completed,
                lessons_completed: response.data.data.lessons_completed
              });

        } catch (error) {
            this.context.commit(Mutations.SET_PUBLIC_USER, {});
            posthog.capture('error_viewing_public_profile', {
                user_id: id,
                error: error
            });
            this.errors = error;
            
        }
    }

    @Action
    async [Actions.GET_ACCOUNT_PROFILE]() {
        try {
            const { data } = await ApiService.get("account/profile");
            if (data?.data) {
            this.context.commit(Mutations.SET_AUTH, data.data);
            try {
                const patent_hakai = data.data.achievements?.find((obj: { type: string }) => obj.type === "patent_hakai");
                if (patent_hakai && !patent_hakai.is_read) {
                this.context.commit(Mutations.SET_SHOW_HAKAI_ACHIEVEMENTS, true);
                }
            } catch (e) {
                console.error("Error checking patent_hakai achievement:", e);
            }
            try {
                const certification = data.data.achievements?.find((obj: { type: string }) => obj.type === "certification_completed");
                if (certification && !certification.is_read) {
                this.context.commit(Mutations.SET_SHOW_CERTIFICATION_ACHIEVEMENTS, true);
                }
            } catch (e) {
                console.error("Error checking certification achievement:", e);
            }
            }
        } catch (error) {
            console.error("Error fetching account profile:", error);
        }
    }

    @Mutation
    [Mutations.SET_PUBLIC_USER](user: UserType) {
        this.user = user;
    }


}